export var VerticalSkin;
(function (VerticalSkin) {
    VerticalSkin["Default"] = "";
})(VerticalSkin || (VerticalSkin = {}));
let verticalSkin = undefined;
export function getVerticalSkin() {
    return verticalSkin;
}
export function setVerticalSkinIfNotSet(force = false) {
    if (force || !verticalSkin) {
        verticalSkin = VerticalSkin.Default;
    }
}
//# sourceMappingURL=verticalSkins.js.map